import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import scan from "../../assets/module-2/2-2-8-scan.png";
import LdsImage from "../../components/LdsImage";
import FigureCaption from "../../components/LdsFigureCaption";
import References from "../../components/References";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.2.8 Criteria for a Positive Scan
            </h1>
            <p className="me-4">Estimated time to complete: 1 minute</p>
          </section>

          <section className="row mt-5 mb-4 justify-content-center">
            <div className="col-lg-6 col-10">
              <FigureCaption
                noCollapse={true}
                className="figcaption-no-border align-items-center flex-column d-flex"
                radiusSize="small"
                textContent={
                  <>
                    <p className="gray">
                      &copy;2016. Avid Radiopharmaceuticals, Inc. All rights reserved. Data on File, Lilly Research Laboratories: AMY20121001B.
                    </p>
                  </>
                }
              >
                <LdsImage
                  src={scan}
                  alt="A brain scan labeled as positive, showing the presence of amyloid plaques, with the title 'Amyvid Scans' in orange text."
                />
              </FigureCaption>
            </div>
          </section>

          <section className="row mb-4 justify-content-center">
            <div className="col-12 col-lg-8">
              <h5 className="b">
                Positive scans MUST have at least 1 of the following:
              </h5>
              <ul className="ms-0">
                <li>
                  2 or more regions in which there is reduced or absent
                  gray-white contrast; this is the most common appearance of a
                  positive scan
                </li>
                <li>
                  <strong>Note:</strong> A region of reduced or absent
                  gray-white contrast within a lobe of the brain:
                  <ul className="ms-0">
                    <li>Must be larger than a single cortical gyrus</li>
                    <li>
                      Must be seen on at least 2 adjacent slices of the scan
                    </li>
                  </ul>
                </li>
              </ul>
              <p className="text-center">OR</p>
              <ul className="ms-0 mt-4">
                <li>
                  1 or more regions in which gray matter radioactivity is
                  intense and clearly exceeds radioactivity in adjacent white
                  matter
                </li>
                <ul>
                  <li>
                    <strong>Note:</strong> The region of intense gray matter
                    radioactivity must be seen on at least 2 adjacent slices of
                    the scan
                  </li>
                </ul>
              </ul>
            </div>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-2-7", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-2/module-2-2-9", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>

          <References>
            <p className="fz-sm gray">
              Amyvid (florbetapir F 18 injection). Prescribing Information. Lilly USA, LLC.
            </p>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
